<template>
  <div class="list-container">
    <DxList
      ref="dxList"
      :data-source="logSource"
      :height="heightList"
      :width="widthList"
      :search-enabled="true"
      search-mode="contains"
      :search-expr="[
        'created_at_text',
        'description',
        'users_name',
        'log_name',
      ]"
      search-placeholder="Hari, tanggal, jam"
    >
      <template #item="{ data }">
        <div>
          <strong>{{ data.created_at_text }}</strong>
          {{ data.description }} by {{ data.users_name }} ({{ data.log_name }})
        </div>
        <div>
          <strong>Nama:</strong>
          {{ formatProperties(data.properties.parent_name) }}<br />
          <strong>Baru:</strong>
          {{ formatProperties(data.properties.attributes) }}<br />
          <strong>Lama:</strong> {{ formatProperties(data.properties.old) }}
        </div>
      </template>
    </DxList>
  </div>
</template>
<style scoped>
.list-container :deep(.dx-list-item-content) {
  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: break-word;
}

.list-container :deep(.dx-list-item) {
  height: auto !important;
}
</style>

<script>
import DxList from "devextreme-vue/list";
import { computed } from "vue";
export default {
  components: {
    DxList,
  },
  props: {
    heightList: {
      type: Number,
      default: 800,
    },
    widthList: {
      type: Number,
      default: 800,
    },
    logData: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const logSource = computed(() => {
      // return _.filter(commonStore.gajiSkemaKomponenStore, (item) => {
      //   return _.get(item, "gaji_skema_id") === props.gajiSkemaId;
      // });
      return props.logData;
    });
    const formatProperties = (val) => {
      // if (!val) return "-";
      // if (typeof val === "object") return JSON.stringify(val);
      return val;
    };

    return {
      logSource,
      formatProperties,
    };
  },
};
</script>
